import type { InputProps } from '@rulebooks/evidend-titan';
import { Input } from '@rulebooks/evidend-titan';
import React from 'react';

export const FakeInput = ({ isLabelHidden = false, ...props }: Omit<InputProps, 'name'>) => {
  return <Input isLabelHidden={isLabelHidden} name="" {...props} readOnly />;
};
